.success > * {
    color: var(--success);
}
